import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import { API } from '../api';
import { toast } from 'react-toastify';

export default function ManageAttractions() {

  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [total, setTotal] = useState(0);

  const [form, setForm] = useState({
    attraction_name: '',
    attraction_descp: '',
    image: null
  });

  const [editId, setEditId] = useState(null);

  const fetchData = () => {
    API.get(`/attractions?page=${page}&limit=${limit}`)
      .then(res => {
        setData(res.data.data);
        setTotal(res.data.total);
      });
  };

  useEffect(() => {
    fetchData();
  }, [page]);

  // SUBMIT
  const handleSubmit = async () => {
    const fd = new FormData();
    fd.append("attraction_name", form.attraction_name);
    fd.append("attraction_descp", form.attraction_descp);
    if (form.image) fd.append("image", form.image);

    try {
      if (editId) {
        await API.put(`/attractions/${editId}`, fd);
        toast.success("Updated");
      } else {
        await API.post('/attractions', fd);
        toast.success("Added");
      }

      setForm({ attraction_name:'', attraction_descp:'', image:null });
      setEditId(null);
      fetchData();

    } catch {
      toast.error("Error");
    }
  };

  // DELETE
  const handleDelete = async (id) => {
    if (!window.confirm("Delete?")) return;
    await API.delete(`/attractions/${id}`);
    fetchData();
  };

  // STATUS
  const toggleStatus = async (row) => {
    await API.put(`/attractions/status/${row.attraction_id}`, {
      status: row.attraction_status ? 0 : 1
    });
    fetchData();
  };
 

  const totalPages = Math.ceil(total / limit);

  return (
    <Layout activePage="Attractions">

<div style={S.header}>
        <h2 style={S.title}>Manage Attractions</h2>
        <p style={S.subtitle}>Add and manage Attractions</p>
      </div>

      {/* FORM */}
      <div style={{... S.card,padding:'20px',marginBottom:'30px'}}>
        <div style={S.grid2} >
          <div style={S.fg} >
          <label style={S.label}>Attraction Name <span style={S.req}>*</span></label>
        <input style={S.input}
          placeholder="Attraction Name"
          value={form.attraction_name}
          onChange={e=>setForm({...form, attraction_name:e.target.value})}
        />
       </div>
       <div style={S.fg} >
        <label style={S.label}>Attraction Image <span style={S.req}>*</span></label>
        <input style={S.fileBtn}
          type="file"
          onChange={e=>setForm({...form, image:e.target.files[0]})}
        />
        </div>
        </div>

        <div style={S.fg} >
        <label style={S.label}>Description <span style={S.req}>*</span></label>
        <textarea style={S.input}
          placeholder="Description"
          value={form.attraction_descp}
          onChange={e=>setForm({...form, attraction_descp:e.target.value})}
        />
        </div>

        <button style={S.addBtn} onClick={handleSubmit}>
          {editId ? "Update" : "Save"}
        </button>
      </div>

      {/* TABLE */}
      <div style={S.card}>
        <table style={S.table}>
          <thead>
            <tr>
              <th style={S.th}>#</th>
              <th style={S.th}>Name</th>
              <th style={S.th}>Image</th>
              <th style={S.th}>Description</th>
              <th style={S.th}>Action</th>
            </tr>
          </thead>

          <tbody>
            {data.map((row, i) => {
              const isActive = Number(row.attraction_status) === 1;

              return(
              <tr key={row.attraction_id}>
                <td style={S.td}><span style={S.serial}>{(page-1)*limit + i + 1}</span></td>
                <td style={S.td}><span style={S.nameChip}>{row.attraction_name}</span></td>

                <td style={S.td}>
                  <img
                    src={`http://192.168.0.57:5000/attraction/${row.attraction_img}`}
                    width="80"
                  />
                </td>

                <td style={S.td}><span style={S.groupChip}>{row.attraction_descp}</span></td>

                <td style={S.td}>
                  <button style={S.editBtn} onClick={()=>{
                    setForm({
                      attraction_name: row.attraction_name,
                      attraction_descp: row.attraction_descp
                    });
                    setEditId(row.attraction_id);
                  }}>Edit</button>

                  <button style={S.delBtn} onClick={()=>handleDelete(row.attraction_id)}>
                    Delete
                  </button>

                  <button onClick={()=>toggleStatus(row)}
                  
                    style={{
                          ...S.statusBtn,
                          background: isActive ? '#f0fff6' : '#fff0f0',
                          color:      isActive ? '#1a9e5c' : '#c0392b',
                          border:     `1px solid ${isActive ? '#b8f0d0' : '#fca5a5'}`,
                        }}>
                        {isActive ? '✅ Active' : '❌ Inactive'}
                  </button>
                </td>
              </tr>
              );
                      })}
          </tbody>
        </table>

        {/* PAGINATION */}
        <div style={S.pagination}>
          <span style={S.paginInfo}>
            {total > 0 ? `Showing ${(page-1)*10+1}–${Math.min(page*10, total)} of ${total}` : ''}
          </span>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <button style={S.pgBtn} disabled={page===1} onClick={()=>setPage(page-1)}>Prev</button>
          <span style={S.paginInfo}>{page} / {totalPages}</span>
          <button style={S.pgBtn} disabled={page===totalPages} onClick={()=>setPage(page+1)}>Next</button>
        </div>
        </div>
      </div>

    </Layout>
  );
}


/* ─── Styles ─── */
const S = {
    root: { display: 'flex', minHeight: '100vh', background: '#f4f6fb', fontFamily: "'DM Sans','Segoe UI',sans-serif" },
  
    /* Header */
  header: { marginBottom: 20 },
  title: { margin: 0, fontSize: 26, fontWeight: 800, color: '#1a1d2e', letterSpacing: '-0.5px' },
  subtitle: { margin: '4px 0 0', fontSize: 13, color: '#999' },

    /* Main */
    main: { flex: 1, padding: '28px 28px 40px', minWidth: 0, transition: 'margin-left 0.25s' },
    topbar: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20 },
    title: { margin: 0, fontSize: 26, fontWeight: 800, color: '#1a1d2e', letterSpacing: '-0.5px' },
    subtitle: { margin: '4px 0 0', fontSize: 13, color: '#999' },
    addBtn: { padding: '10px 22px', background: 'linear-gradient(135deg,#6C63FF,#43BCCD)',
      color: '#fff', border: 'none', borderRadius: 10, cursor: 'pointer',marginTop:'10px',
      fontSize: 14, fontWeight: 700, fontFamily: 'inherit', boxShadow: '0 4px 14px rgba(108,99,255,0.35)' },
  
    /* Filters */
    filterRow: { display: 'flex', gap: 12, marginBottom: 20, flexWrap: 'wrap' },
    searchWrap: { display: 'flex', alignItems: 'center', gap: 8, background: '#fff',
      border: '1px solid #e8e8e8', borderRadius: 10, padding: '8px 14px',
      flex: 1, minWidth: 220, boxShadow: '0 2px 8px rgba(0,0,0,0.04)' },
    searchInput: { border: 'none', outline: 'none', fontSize: 13, flex: 1,
      fontFamily: 'inherit', color: '#333', background: 'transparent' },
    clearBtn: { background: 'none', border: 'none', cursor: 'pointer', color: '#aaa', fontSize: 12, padding: 0 },
    filterSelect: { padding: '9px 14px', border: '1.5px solid #e0e0e0', borderRadius: 10,
      fontSize: 13, fontFamily: 'inherit', color: '#333', outline: 'none',
      background: '#fff', minWidth: 180 },
  
    /* Card + Table */
    card: { background: '#fff', borderRadius: 16, boxShadow: '0 2px 16px rgba(0,0,0,0.06)', overflow: 'hidden' },
    table: { width: '100%', borderCollapse: 'collapse' },
    theadRow: { background: '#fafafa' },
    th: { padding: '12px 14px', fontSize: 11, fontWeight: 700, color: '#999',
      textAlign: 'center', borderBottom: '2px solid #f0f0f0',
      textTransform: 'uppercase', letterSpacing: '0.5px' },
    tr: { transition: 'background 0.12s' },
    td: { padding: '12px 14px', fontSize: 13, color: '#333', borderBottom: '1px solid #f8f8f8', textAlign: 'center' },
    emptyCell: { textAlign: 'center', padding: 40, color: '#bbb', fontSize: 14 },
    noImg: { width: 60, height: 40, background: '#f3f2ff', borderRadius: 6,
      display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20 },
  
    /* Chips */
    serial:     { background: '#f3f2ff', color: '#6C63FF', borderRadius: 20, padding: '3px 10px', fontSize: 12, fontWeight: 700 },
    nameChip:   { background: '#f0fff6', color: '#1a9e5c', borderRadius: 20, padding: '4px 12px', fontSize: 12, fontWeight: 600 },
    groupChip:  { background: '#f0f8ff', color: '#1a6eb5', borderRadius: 20, padding: '4px 12px', fontSize: 12, fontWeight: 600 },
    stockChip:  { background: '#fff3f0', color: '#d45700', borderRadius: 20, padding: '3px 10px', fontSize: 12, fontWeight: 700 },
    badge:      { borderRadius: 20, padding: '3px 10px', fontSize: 12, fontWeight: 600 },
    pctChip:   { borderRadius: 20, padding: '4px 12px', fontSize: 13, fontWeight: 700 },
    /* Action buttons */
    viewBtn: { marginRight: 5, background: '#f0fff6', color: '#1a9e5c',
      border: '1px solid #b8f0d0', padding: '4px 12px',
      borderRadius: 20, cursor: 'pointer', fontSize: 12, fontWeight: 700, fontFamily: 'inherit' },
    editBtn: { marginRight: 5, background: '#f3f2ff', color: '#6C63FF',
      border: '1px solid #d4d0ff', padding: '4px 12px',
      borderRadius: 20, cursor: 'pointer', fontSize: 12, fontWeight: 700, fontFamily: 'inherit' },
    delBtn: { background: '#fff2f5', color: '#FF6584', border: '1px solid #ffd0d8',
      padding: '4px 12px', borderRadius: 20, cursor: 'pointer',
      fontSize: 12, fontWeight: 700, fontFamily: 'inherit' },
      fileBtn:      { padding: '8px 16px', background: '#f3f2ff', color: '#6C63FF', border: '1px solid #d4d0ff', borderRadius: 8, cursor: 'pointer', fontSize: 12, fontWeight: 600, fontFamily: 'inherit' },
  statusBtn:    { padding: '5px 14px', borderRadius: 20, cursor: 'pointer', fontSize: 12, fontWeight: 700, fontFamily: 'inherit' },
  
    /* Pagination */
    pagination: { display: 'flex', justifyContent: 'space-between', alignItems: 'center',
      padding: '14px 20px', borderTop: '1px solid #f0f0f0' },
    paginInfo: { fontSize: 12, color: '#999' },
    pgBtn: { padding: '5px 14px', background: '#f3f2ff', color: '#6C63FF',
      border: '1px solid #d4d0ff', borderRadius: 8, cursor: 'pointer',
      fontSize: 12, fontWeight: 600, fontFamily: 'inherit' },
  
    /* Modal */
    overlay: { position: 'fixed', inset: 0, background: 'rgba(10,10,30,0.55)', zIndex: 999,
      display: 'flex', alignItems: 'center', justifyContent: 'center', backdropFilter: 'blur(2px)' },
    modalBox: { background: '#fff', borderRadius: 20, width: 740, maxWidth: '96vw', maxHeight: '90vh',
      display: 'flex', flexDirection: 'column', boxShadow: '0 24px 60px rgba(0,0,0,0.2)' },
    modalHead: { display: 'flex', justifyContent: 'space-between', alignItems: 'center',
      padding: '18px 22px', borderBottom: '1px solid #f0f0f0', flexShrink: 0 },
    modalBody: { padding: '20px 22px', overflowY: 'auto', flex: 1 },
    modalFoot: { display: 'flex', justifyContent: 'flex-end', gap: 10,
      padding: '14px 22px', borderTop: '1px solid #f0f0f0', flexShrink: 0 },
    closeBtn: { background: '#ff6b6b22', border: 'none', color: '#ff6b6b',
      borderRadius: '50%', width: 30, height: 30, cursor: 'pointer', fontWeight: 800, fontSize: 14 },
    cancelBtn: { padding: '9px 20px', background: '#f5f5f5', color: '#666',
      border: 'none', borderRadius: 10, cursor: 'pointer', fontSize: 13, fontWeight: 600, fontFamily: 'inherit' },
    submitBtn: { padding: '9px 22px', background: 'linear-gradient(135deg,#6C63FF,#43BCCD)',
      color: '#fff', border: 'none', borderRadius: 10, cursor: 'pointer',
      fontSize: 13, fontWeight: 700, fontFamily: 'inherit' },
  
    /* Form */
    section: { fontSize: 11, fontWeight: 800, color: '#6C63FF', textTransform: 'uppercase',
      letterSpacing: '0.8px', margin: '18px 0 10px', paddingBottom: 6,
      borderBottom: '1.5px solid #f3f2ff' },
    grid2: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 14 },
    grid4: { display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 12, marginBottom: 14 },
    fg: { display: 'flex', flexDirection: 'column', gap: 5 },
    label: { fontSize: 12, fontWeight: 600, color: '#555' },
    req: { color: '#ff6b6b' },
    input: { padding: '8px 12px', border: '1.5px solid #e0e0e0', borderRadius: 8,
      fontSize: 13, fontFamily: 'inherit', color: '#333', outline: 'none', width: '100%',
      boxSizing: 'border-box' },
  };
  